import React from 'react'
import { connect } from 'react-redux'
import { find } from 'lodash'
import { localized } from '@/decorators/localized'
import { actionCreators } from '@/store/RsaKeys'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import { BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { WhiteBox } from '@/components/Layout'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import LoadingIndicator from '@/components/LoadingIndicator'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'
import { downloadPublicKeyColumnProps, invalidateKeyColumnProps, deleteKeyColumnProps } from './gridActions'
import { Alert } from 'reactstrap'

@localized()
class RsaKeys extends React.Component {
  componentWillMount () {
    this.props.getAll()
  }
  hasAnyValidKey () {
    const rsaKey = find((this.props.rsaKeys || []), x => x.invalidatedAt === null)
    return Boolean(rsaKey)
  }
  isLoading () {
    const { fetching, generating, invalidating, deleting } = this.props
    return fetching || generating || invalidating || deleting
  }
  openDialog () {
    const { openDialog, localize, generateKeys } = this.props
    openDialog({
      dialogType: dialogTypes.inputPassphrase,
      onAction: passphrase => openTwoFactorDialog(() => generateKeys(passphrase)),
      localize
    })
  }
  render () {
    const loading = this.isLoading()
    const { rsaKeys, localize, downloadPublicKey, invalidateKey, deleteRsaKey } = this.props
    const canGenerateKey = !this.hasAnyValidKey()
    return (
      <WhiteBox
        className='RsaKeysManagement'
        header='Security.RsaKeys'
        buttons={<Button
          onClick={() => this.openDialog()}
          confirmText={canGenerateKey ? null : 'Security.ConfirmGenerateRsaMessage'}
          color='primary'
          size='sm'
          className='generate-button pull-right' icon='chip'> <span>{localize('Security.GenerateButton')}</span></Button>}>
        <Alert color='warning'><Resx name='Security.RsaKeysInfo' /></Alert>
        {loading && <LoadingIndicator />}
        {!loading &&
        <BsrsGrid items={rsaKeys} simpleView>
          <Column field='id' title={localize('Common.Id')} width='150px' />
          <Column field='creationTime' title={localize('Security.CreatedAt')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
          <Column field='invalidatedAt' title={localize('Security.InvalidatedAt')} cell={DateCell} filterCell={DateFilterCell} filter='date' width='150px' />
          <Column {...downloadPublicKeyColumnProps({ downloadPublicKey, localize })} width='150px' title={localize('Security.PublicKey')} />
          <Column {...invalidateKeyColumnProps({ invalidateKey, localize })} width='150px' />
          <Column {...deleteKeyColumnProps({ deleteRsaKey, localize })} width='150px' />
        </BsrsGrid>}
      </WhiteBox>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ...state.rsaKeys,
  ...ownProps
})

const mapDispatchToProps = {
  getAll: actionCreators.getAll,
  generateKeys: actionCreators.generateKeys,
  invalidateKey: actionCreators.invalidateKey,
  downloadPublicKey: actionCreators.downloadPublicKey,
  deleteRsaKey: actionCreators.deleteRsaKey,
  openDialog: dialogActions.openDialog
}

export default connect(mapStateToProps, mapDispatchToProps)(RsaKeys)



// WEBPACK FOOTER //
// ./src/components/userProfile/rsaKeys/index.js